"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dev = void 0;
exports.dev = {
    api: {
        baseUrl: 'http://localhost:4000',
    },
    auth0: {
        domain: 'cflin-io-dev.us.auth0.com',
        clientId: 'G4kP39iD05VaIQaeOurCpeDDidTizfai',
    },
    cloudinary: {
        baseFolder: 'dev/',
        signatureApi: 'http://localhost:4000/sign/image',
    },
    mongodb: {
        baseUrl: 'mongodb://localhost',
    },
};
//# sourceMappingURL=dev.js.map